import { Language } from './../../../internationalText';
import { orderBy } from 'lodash';
import _ from 'lodash';
import { AnalysisFilterState } from '../../../Filter/analysisFilterState';
import {
  TagGroupAnalysisGq,
  WordCountIntervalGq,
} from '../../../../../graphql/projects/queries/analysis/useGetHBLtPerTagGroup';
import { internationalText } from '../../../internationalText';

export const segmentNameInterval = (start: number, end: number) => {
  return (
    (start === end ? '' : !start ? '1' : start) +
    (start === end || end === 1 || !end ? '' : '-') +
    (end === 1 ? '' : end ? end + '' : '+')
  );
};

// Configuration for the rank intervals
// Change this to display a different interval
export const wordCountIntervals = (
  analysisFilterState: AnalysisFilterState,
  language: Language
): WordCountIntervalGq[] => {
  return [
    {
      name: internationalText.chart.keyword_specificity_by_topic.head_keyword[language],
      startCount: null,
      endCount: analysisFilterState?.hBLtValues[0] - 1,
    },
    {
      name: internationalText.chart.keyword_specificity_by_topic.body_keyword[language],
      startCount: analysisFilterState?.hBLtValues[0],
      endCount: analysisFilterState?.hBLtValues[1] - 1,
    },
    {
      name: internationalText.chart.keyword_specificity_by_topic.longtail_keyword[language],
      startCount: analysisFilterState?.hBLtValues[1],
      endCount: null,
    },

  ];
};

// Main function for creating data for the chart
export const getBarValues = (
  wordCountIntervals: WordCountIntervalGq[],
  tagGroupAnalyses: TagGroupAnalysisGq[],
  language: Language
) => {
  const orderedAnalyses = orderBy(
    tagGroupAnalyses,
    [(g) => g.hBLtAnalyses.map((x) => x.searchVolume).reduce((a, b) => a + b, 0)],
    ['desc']
  );
  return orderedAnalyses.map((tagGroupAnalysis) => {
    let bar: any = {};

    // Set the bar name
    bar.barName = tagGroupAnalysis.tagGroupName;

    // Set the segment values of the bar
    wordCountIntervals.map((interval, index) => {
      // Find data point (not always present)
      const hBLtAnalyses = tagGroupAnalysis.hBLtAnalyses.find(
        (ia) => ia.startCount === interval.startCount && ia.endCount == interval.endCount
      );

      // Assign value
      const barSegmentName =
        hBLtAnalyses.name +
        ' (' +
        segmentNameInterval(hBLtAnalyses.startCount, hBLtAnalyses.endCount) +
        (hBLtAnalyses.endCount === 1
          ? ` ${internationalText.chart.keyword_specificity_by_topic.word[language]})`
          : ` ${internationalText.chart.keyword_specificity_by_topic.words[language]})`);
      const barSegmentValue = hBLtAnalyses?.searchVolume ?? 0;
      bar[barSegmentName] = barSegmentValue;
    });
    return bar;
  });
};
